// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from './client'
import { client } from './client.gen'
import type {
  AddCoinsAccountBalanceAddPostData,
  AddCoinsAccountBalanceAddPostErrors,
  AddCoinsAccountBalanceAddPostResponses,
  ApproveProductReviewShopReviewsReviewIdApprovePutData,
  ApproveProductReviewShopReviewsReviewIdApprovePutErrors,
  ApproveProductReviewShopReviewsReviewIdApprovePutResponses,
  BlockUserPassportIdmIdmPrivateBlockUserPostData,
  BlockUserPassportIdmIdmPrivateBlockUserPostErrors,
  BlockUserPassportIdmIdmPrivateBlockUserPostResponses,
  BulkAddCoinsAccountBalanceBulkAddPostData,
  BulkAddCoinsAccountBalanceBulkAddPostErrors,
  BulkAddCoinsAccountBalanceBulkAddPostResponses,
  BuyProductShopOrdersPostData,
  BuyProductShopOrdersPostErrors,
  BuyProductShopOrdersPostResponses,
  CancelOrderShopOrdersOrderIdCancelPostData,
  CancelOrderShopOrdersOrderIdCancelPostErrors,
  CancelOrderShopOrdersOrderIdCancelPostResponses,
  CreateCityPassportIdmIdmPrivateCreateCityPostData,
  CreateCityPassportIdmIdmPrivateCreateCityPostErrors,
  CreateCityPassportIdmIdmPrivateCreateCityPostResponses,
  CreateCountryPassportIdmIdmPrivateCreateCountryPostData,
  CreateCountryPassportIdmIdmPrivateCreateCountryPostErrors,
  CreateCountryPassportIdmIdmPrivateCreateCountryPostResponses,
  CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostData,
  CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostErrors,
  CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostResponses,
  CreateEventEventsPostData,
  CreateEventEventsPostErrors,
  CreateEventEventsPostResponses,
  CreateFeedbackCategoryFeedbackCategoriesPostData,
  CreateFeedbackCategoryFeedbackCategoriesPostErrors,
  CreateFeedbackCategoryFeedbackCategoriesPostResponses,
  CreateOfficePassportIdmIdmPrivateCreateOfficePostData,
  CreateOfficePassportIdmIdmPrivateCreateOfficePostErrors,
  CreateOfficePassportIdmIdmPrivateCreateOfficePostResponses,
  CreatePositionPassportIdmIdmPrivateCreatePositionPostData,
  CreatePositionPassportIdmIdmPrivateCreatePositionPostErrors,
  CreatePositionPassportIdmIdmPrivateCreatePositionPostResponses,
  CreatePostPostsPostData,
  CreatePostPostsPostErrors,
  CreatePostPostsPostResponses,
  CreateProductLabelShopProductsLabelsPostData,
  CreateProductLabelShopProductsLabelsPostErrors,
  CreateProductLabelShopProductsLabelsPostResponses,
  CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostData,
  CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostErrors,
  CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostResponses,
  CreateProductShopProductsPostData,
  CreateProductShopProductsPostErrors,
  CreateProductShopProductsPostResponses,
  CreateProductTagShopProductsTagsPostData,
  CreateProductTagShopProductsTagsPostErrors,
  CreateProductTagShopProductsTagsPostResponses,
  CreateQuestionQuestionsPostData,
  CreateQuestionQuestionsPostErrors,
  CreateQuestionQuestionsPostResponses,
  CreateUserPassportIdmIdmPrivateCreateUserPostData,
  CreateUserPassportIdmIdmPrivateCreateUserPostErrors,
  CreateUserPassportIdmIdmPrivateCreateUserPostResponses,
  DebitCoinsAccountBalanceDebitPostData,
  DebitCoinsAccountBalanceDebitPostErrors,
  DebitCoinsAccountBalanceDebitPostResponses,
  DeleteCityPassportIdmIdmPrivateDeleteCityPostData,
  DeleteCityPassportIdmIdmPrivateDeleteCityPostErrors,
  DeleteCityPassportIdmIdmPrivateDeleteCityPostResponses,
  DeleteCountryPassportIdmIdmPrivateDeleteCountryPostData,
  DeleteCountryPassportIdmIdmPrivateDeleteCountryPostErrors,
  DeleteCountryPassportIdmIdmPrivateDeleteCountryPostResponses,
  DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostData,
  DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostErrors,
  DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostResponses,
  DeleteEventEventsEventIdDeleteData,
  DeleteEventEventsEventIdDeleteErrors,
  DeleteEventEventsEventIdDeleteResponses,
  DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteData,
  DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteErrors,
  DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteResponses,
  DeleteOfficePassportIdmIdmPrivateDeleteOfficePostData,
  DeleteOfficePassportIdmIdmPrivateDeleteOfficePostErrors,
  DeleteOfficePassportIdmIdmPrivateDeleteOfficePostResponses,
  DeletePositionPassportIdmIdmPrivateDeletePositionPostData,
  DeletePositionPassportIdmIdmPrivateDeletePositionPostErrors,
  DeletePositionPassportIdmIdmPrivateDeletePositionPostResponses,
  DeletePostPostsPostIdDeleteData,
  DeletePostPostsPostIdDeleteErrors,
  DeletePostPostsPostIdDeleteResponses,
  DeleteProductLabelShopProductsLabelsProductLabelIdDeleteData,
  DeleteProductLabelShopProductsLabelsProductLabelIdDeleteErrors,
  DeleteProductLabelShopProductsLabelsProductLabelIdDeleteResponses,
  DeleteProductShopProductsProductIdDeleteData,
  DeleteProductShopProductsProductIdDeleteErrors,
  DeleteProductShopProductsProductIdDeleteResponses,
  DeleteProductTagShopProductsTagsProductTagIdDeleteData,
  DeleteProductTagShopProductsTagsProductTagIdDeleteErrors,
  DeleteProductTagShopProductsTagsProductTagIdDeleteResponses,
  DeleteQuestionQuestionsQuestionsIdDeleteData,
  DeleteQuestionQuestionsQuestionsIdDeleteErrors,
  DeleteQuestionQuestionsQuestionsIdDeleteResponses,
  ExportJournalAccountJournalExportGetData,
  ExportJournalAccountJournalExportGetErrors,
  ExportJournalAccountJournalExportGetResponses,
  ExportOrdersExcelShopOrdersExportGetData,
  ExportOrdersExcelShopOrdersExportGetErrors,
  ExportOrdersExcelShopOrdersExportGetResponses,
  ExportStockExcelShopExportStockGetData,
  ExportStockExcelShopExportStockGetErrors,
  ExportStockExcelShopExportStockGetResponses,
  GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetData,
  GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetErrors,
  GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetResponses,
  GetBalanceAccountBalanceGetData,
  GetBalanceAccountBalanceGetErrors,
  GetBalanceAccountBalanceGetResponses,
  GetBrandConfigBrandingGetData,
  GetBrandConfigBrandingGetErrors,
  GetBrandConfigBrandingGetResponses,
  GetCityInfoPassportIdmIdmGetCityInfoPostData,
  GetCityInfoPassportIdmIdmGetCityInfoPostErrors,
  GetCityInfoPassportIdmIdmGetCityInfoPostResponses,
  GetCityPassportIdmIdmPrivateGetCityPostData,
  GetCityPassportIdmIdmPrivateGetCityPostErrors,
  GetCityPassportIdmIdmPrivateGetCityPostResponses,
  GetCountryInfoPassportIdmIdmGetCountryInfoPostData,
  GetCountryInfoPassportIdmIdmGetCountryInfoPostErrors,
  GetCountryInfoPassportIdmIdmGetCountryInfoPostResponses,
  GetCountryPassportIdmIdmPrivateGetCountryPostData,
  GetCountryPassportIdmIdmPrivateGetCountryPostErrors,
  GetCountryPassportIdmIdmPrivateGetCountryPostResponses,
  GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetData,
  GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetErrors,
  GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetResponses,
  GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostData,
  GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostErrors,
  GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostResponses,
  GetDeliveryAddressShopDeliveryAddressUserIdGetData,
  GetDeliveryAddressShopDeliveryAddressUserIdGetErrors,
  GetDeliveryAddressShopDeliveryAddressUserIdGetResponses,
  GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostData,
  GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostErrors,
  GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostResponses,
  GetDepartmentPassportIdmIdmPrivateGetDepartmentPostData,
  GetDepartmentPassportIdmIdmPrivateGetDepartmentPostErrors,
  GetDepartmentPassportIdmIdmPrivateGetDepartmentPostResponses,
  GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostData,
  GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostErrors,
  GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostResponses,
  GetEventEventsEventIdGetData,
  GetEventEventsEventIdGetErrors,
  GetEventEventsEventIdGetResponses,
  GetEventsEventsGetData,
  GetEventsEventsGetErrors,
  GetEventsEventsGetResponses,
  GetFeedbackCategoriesFeedbackCategoriesGetData,
  GetFeedbackCategoriesFeedbackCategoriesGetErrors,
  GetFeedbackCategoriesFeedbackCategoriesGetResponses,
  GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetData,
  GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetErrors,
  GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetResponses,
  GetHistoryAccountHistoryGetData,
  GetHistoryAccountHistoryGetErrors,
  GetHistoryAccountHistoryGetResponses,
  GetImageProxyMediaIdImgproxyProcessingOptionsGetData,
  GetImageProxyMediaIdImgproxyProcessingOptionsGetErrors,
  GetImageProxyMediaIdImgproxyProcessingOptionsGetResponses,
  GetImportTemplateAccountBalanceImportTemplateGetData,
  GetImportTemplateAccountBalanceImportTemplateGetErrors,
  GetImportTemplateAccountBalanceImportTemplateGetResponses,
  GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetData,
  GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetErrors,
  GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetResponses,
  GetJournalAccountJournalGetData,
  GetJournalAccountJournalGetErrors,
  GetJournalAccountJournalGetResponses,
  GetJournalDetailAccountJournalJournalRecordIdGetData,
  GetJournalDetailAccountJournalJournalRecordIdGetErrors,
  GetJournalDetailAccountJournalJournalRecordIdGetResponses,
  GetOfficeInfoPassportIdmIdmGetOfficeInfoPostData,
  GetOfficeInfoPassportIdmIdmGetOfficeInfoPostErrors,
  GetOfficeInfoPassportIdmIdmGetOfficeInfoPostResponses,
  GetOfficePassportIdmIdmPrivateGetOfficePostData,
  GetOfficePassportIdmIdmPrivateGetOfficePostErrors,
  GetOfficePassportIdmIdmPrivateGetOfficePostResponses,
  GetOrdersShopOrdersGetData,
  GetOrdersShopOrdersGetErrors,
  GetOrdersShopOrdersGetResponses,
  GetOrderStatesShopOrdersOrderIdStatesGetData,
  GetOrderStatesShopOrdersOrderIdStatesGetErrors,
  GetOrderStatesShopOrdersOrderIdStatesGetResponses,
  GetPositionPassportIdmIdmPrivateGetPositionPostData,
  GetPositionPassportIdmIdmPrivateGetPositionPostErrors,
  GetPositionPassportIdmIdmPrivateGetPositionPostResponses,
  GetPostPostsPostIdGetData,
  GetPostPostsPostIdGetErrors,
  GetPostPostsPostIdGetResponses,
  GetPostsPostsGetData,
  GetPostsPostsGetErrors,
  GetPostsPostsGetResponses,
  GetProductShopProductsProductIdGetData,
  GetProductShopProductsProductIdGetErrors,
  GetProductShopProductsProductIdGetResponses,
  GetProductsShopProductsGetData,
  GetProductsShopProductsGetErrors,
  GetProductsShopProductsGetResponses,
  GetProductTagsShopProductsTagsGetData,
  GetProductTagsShopProductsTagsGetErrors,
  GetProductTagsShopProductsTagsGetResponses,
  GetQuestionsQuestionsGetData,
  GetQuestionsQuestionsGetErrors,
  GetQuestionsQuestionsGetResponses,
  GetReviewAdminShopReviewsReviewIdGetData,
  GetReviewAdminShopReviewsReviewIdGetErrors,
  GetReviewAdminShopReviewsReviewIdGetResponses,
  GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetData,
  GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetErrors,
  GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetResponses,
  GetTenantBonusesConfigsTenantBonusesGetData,
  GetTenantBonusesConfigsTenantBonusesGetErrors,
  GetTenantBonusesConfigsTenantBonusesGetResponses,
  GetTenantPortalConfigTenantPortalGetData,
  GetTenantPortalConfigTenantPortalGetErrors,
  GetTenantPortalConfigTenantPortalGetResponses,
  GetTenantServicesConfigTenantServicesGetData,
  GetTenantServicesConfigTenantServicesGetErrors,
  GetTenantServicesConfigTenantServicesGetResponses,
  GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetData,
  GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetErrors,
  GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetResponses,
  GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetData,
  GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetErrors,
  GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetResponses,
  GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetData,
  GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetErrors,
  GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetResponses,
  GetUserBalanceAccountBalanceUserUserIdGetData,
  GetUserBalanceAccountBalanceUserUserIdGetErrors,
  GetUserBalanceAccountBalanceUserUserIdGetResponses,
  GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetData,
  GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetErrors,
  GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetResponses,
  GetUsersBalanceAccountBalanceUsersGetData,
  GetUsersBalanceAccountBalanceUsersGetErrors,
  GetUsersBalanceAccountBalanceUsersGetResponses,
  GetUsersNearBirthdaysUsersNearBirthdaysGetData,
  GetUsersNearBirthdaysUsersNearBirthdaysGetErrors,
  GetUsersNearBirthdaysUsersNearBirthdaysGetResponses,
  ImportConfirmAccountBalanceImportConfirmPostData,
  ImportConfirmAccountBalanceImportConfirmPostErrors,
  ImportConfirmAccountBalanceImportConfirmPostResponses,
  ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostData,
  ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostErrors,
  ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostResponses,
  ImportValidateAccountBalanceImportValidatePostData,
  ImportValidateAccountBalanceImportValidatePostErrors,
  ImportValidateAccountBalanceImportValidatePostResponses,
  ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostData,
  ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostErrors,
  ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostResponses,
  ListCitiesInfoPassportIdmIdmListCitiesInfoPostData,
  ListCitiesInfoPassportIdmIdmListCitiesInfoPostErrors,
  ListCitiesInfoPassportIdmIdmListCitiesInfoPostResponses,
  ListCitiesPassportIdmIdmPrivateListCitiesPostData,
  ListCitiesPassportIdmIdmPrivateListCitiesPostErrors,
  ListCitiesPassportIdmIdmPrivateListCitiesPostResponses,
  ListCountriesInfoPassportIdmIdmListCountriesInfoPostData,
  ListCountriesInfoPassportIdmIdmListCountriesInfoPostErrors,
  ListCountriesInfoPassportIdmIdmListCountriesInfoPostResponses,
  ListCountriesPassportIdmIdmPrivateListCountriesPostData,
  ListCountriesPassportIdmIdmPrivateListCountriesPostErrors,
  ListCountriesPassportIdmIdmPrivateListCountriesPostResponses,
  ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostData,
  ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostErrors,
  ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostResponses,
  ListOfficesInfoPassportIdmIdmListOfficesInfoPostData,
  ListOfficesInfoPassportIdmIdmListOfficesInfoPostErrors,
  ListOfficesInfoPassportIdmIdmListOfficesInfoPostResponses,
  ListOfficesPassportIdmIdmPrivateListOfficesPostData,
  ListOfficesPassportIdmIdmPrivateListOfficesPostErrors,
  ListOfficesPassportIdmIdmPrivateListOfficesPostResponses,
  ListPositionsPassportIdmIdmPrivateListPositionsPostData,
  ListPositionsPassportIdmIdmPrivateListPositionsPostErrors,
  ListPositionsPassportIdmIdmPrivateListPositionsPostResponses,
  ListProductLabelsShopProductsLabelsGetData,
  ListProductLabelsShopProductsLabelsGetErrors,
  ListProductLabelsShopProductsLabelsGetResponses,
  ListProductReviewsShopProductsProductIdReviewsGetData,
  ListProductReviewsShopProductsProductIdReviewsGetErrors,
  ListProductReviewsShopProductsProductIdReviewsGetResponses,
  ListReviewsAdminShopReviewsGetData,
  ListReviewsAdminShopReviewsGetErrors,
  ListReviewsAdminShopReviewsGetResponses,
  ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostData,
  ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostErrors,
  ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostResponses,
  ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostData,
  ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostErrors,
  ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostResponses,
  RejectProductReviewShopReviewsReviewIdRejectPutData,
  RejectProductReviewShopReviewsReviewIdRejectPutErrors,
  RejectProductReviewShopReviewsReviewIdRejectPutResponses,
  RestoreProductShopProductsProductIdRestorePutData,
  RestoreProductShopProductsProductIdRestorePutErrors,
  RestoreProductShopProductsProductIdRestorePutResponses,
  SendFeedbackFeedbackSendPostData,
  SendFeedbackFeedbackSendPostErrors,
  SendFeedbackFeedbackSendPostResponses,
  SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutData,
  SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutErrors,
  SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutResponses,
  SetOrderStateShopOrdersOrderIdStatesPostData,
  SetOrderStateShopOrdersOrderIdStatesPostErrors,
  SetOrderStateShopOrdersOrderIdStatesPostResponses,
  SetOrderTrackCodeShopOrdersOrderIdTrackCodePostData,
  SetOrderTrackCodeShopOrdersOrderIdTrackCodePostErrors,
  SetOrderTrackCodeShopOrdersOrderIdTrackCodePostResponses,
  SetUserAvatarUsersUserIdAvatarPutData,
  SetUserAvatarUsersUserIdAvatarPutErrors,
  SetUserAvatarUsersUserIdAvatarPutResponses,
  SetUserRoleUsersUserIdRolePutData,
  SetUserRoleUsersUserIdRolePutErrors,
  SetUserRoleUsersUserIdRolePutResponses,
  ToggleLikePostPostsPostIdToggleLikePostData,
  ToggleLikePostPostsPostIdToggleLikePostErrors,
  ToggleLikePostPostsPostIdToggleLikePostResponses,
  TransferCoinsAccountBalanceTransferPostData,
  TransferCoinsAccountBalanceTransferPostErrors,
  TransferCoinsAccountBalanceTransferPostResponses,
  UnblockUserPassportIdmIdmPrivateUnblockUserPostData,
  UnblockUserPassportIdmIdmPrivateUnblockUserPostErrors,
  UnblockUserPassportIdmIdmPrivateUnblockUserPostResponses,
  UpdateBrandConfigBrandingPostData,
  UpdateBrandConfigBrandingPostErrors,
  UpdateBrandConfigBrandingPostResponses,
  UpdateCityPassportIdmIdmPrivateUpdateCityPostData,
  UpdateCityPassportIdmIdmPrivateUpdateCityPostErrors,
  UpdateCityPassportIdmIdmPrivateUpdateCityPostResponses,
  UpdateCountryPassportIdmIdmPrivateUpdateCountryPostData,
  UpdateCountryPassportIdmIdmPrivateUpdateCountryPostErrors,
  UpdateCountryPassportIdmIdmPrivateUpdateCountryPostResponses,
  UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostData,
  UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostErrors,
  UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostResponses,
  UpdateEventEventsEventIdPutData,
  UpdateEventEventsEventIdPutErrors,
  UpdateEventEventsEventIdPutResponses,
  UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutData,
  UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutErrors,
  UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutResponses,
  UpdateOfficePassportIdmIdmPrivateUpdateOfficePostData,
  UpdateOfficePassportIdmIdmPrivateUpdateOfficePostErrors,
  UpdateOfficePassportIdmIdmPrivateUpdateOfficePostResponses,
  UpdatePositionPassportIdmIdmPrivateUpdatePositionPostData,
  UpdatePositionPassportIdmIdmPrivateUpdatePositionPostErrors,
  UpdatePositionPassportIdmIdmPrivateUpdatePositionPostResponses,
  UpdatePostPostsPostIdPutData,
  UpdatePostPostsPostIdPutErrors,
  UpdatePostPostsPostIdPutResponses,
  UpdateProductLabelShopProductsLabelsProductLabelIdPutData,
  UpdateProductLabelShopProductsLabelsProductLabelIdPutErrors,
  UpdateProductLabelShopProductsLabelsProductLabelIdPutResponses,
  UpdateProductShopProductsProductIdPutData,
  UpdateProductShopProductsProductIdPutErrors,
  UpdateProductShopProductsProductIdPutResponses,
  UpdateProductStockShopProductsProductIdStockPutData,
  UpdateProductStockShopProductsProductIdStockPutErrors,
  UpdateProductStockShopProductsProductIdStockPutResponses,
  UpdateProductTagShopProductsTagsProductTagIdPutData,
  UpdateProductTagShopProductsTagsProductTagIdPutErrors,
  UpdateProductTagShopProductsTagsProductTagIdPutResponses,
  UpdateQuestionQuestionsQuestionsIdPutData,
  UpdateQuestionQuestionsQuestionsIdPutErrors,
  UpdateQuestionQuestionsQuestionsIdPutResponses,
  UpdateTenantPortalConfigTenantPortalPostData,
  UpdateTenantPortalConfigTenantPortalPostErrors,
  UpdateTenantPortalConfigTenantPortalPostResponses,
  UpdateTenantRefillsConfigTenantBonusesPostData,
  UpdateTenantRefillsConfigTenantBonusesPostErrors,
  UpdateTenantRefillsConfigTenantBonusesPostResponses,
  UpdateTenantServicesConfigTenantServicesPostData,
  UpdateTenantServicesConfigTenantServicesPostErrors,
  UpdateTenantServicesConfigTenantServicesPostResponses,
  UpdateUserPassportIdmIdmPrivateUpdateUserPostData,
  UpdateUserPassportIdmIdmPrivateUpdateUserPostErrors,
  UpdateUserPassportIdmIdmPrivateUpdateUserPostResponses,
  UploadImageMediaUploadPostData,
  UploadImageMediaUploadPostErrors,
  UploadImageMediaUploadPostResponses,
  UpsertDeliveryAddressShopDeliveryAddressUserIdPostData,
  UpsertDeliveryAddressShopDeliveryAddressUserIdPostErrors,
  UpsertDeliveryAddressShopDeliveryAddressUserIdPostResponses,
  VersionVersionGetData,
  VersionVersionGetResponses,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Version
 */
export const versionVersionGet = <ThrowOnError extends boolean = false>(
  options?: Options<VersionVersionGetData, ThrowOnError>,
): RequestResult<VersionVersionGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<VersionVersionGetResponses, unknown, ThrowOnError>({ url: '/version', ...options })

/**
 * Get Posts
 */
export const getPostsPostsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetPostsPostsGetData, ThrowOnError>,
): RequestResult<GetPostsPostsGetResponses, GetPostsPostsGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetPostsPostsGetResponses, GetPostsPostsGetErrors, ThrowOnError>({
    url: '/posts',
    ...options,
  })

/**
 * Create Post
 */
export const createPostPostsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreatePostPostsPostData, ThrowOnError>,
): RequestResult<CreatePostPostsPostResponses, CreatePostPostsPostErrors, ThrowOnError> =>
  (options.client ?? client).post<CreatePostPostsPostResponses, CreatePostPostsPostErrors, ThrowOnError>({
    url: '/posts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Post
 */
export const deletePostPostsPostIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeletePostPostsPostIdDeleteData, ThrowOnError>,
): RequestResult<DeletePostPostsPostIdDeleteResponses, DeletePostPostsPostIdDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeletePostPostsPostIdDeleteResponses,
    DeletePostPostsPostIdDeleteErrors,
    ThrowOnError
  >({ url: '/posts/{post_id}', ...options })

/**
 * Get Post
 */
export const getPostPostsPostIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetPostPostsPostIdGetData, ThrowOnError>,
): RequestResult<GetPostPostsPostIdGetResponses, GetPostPostsPostIdGetErrors, ThrowOnError> =>
  (options.client ?? client).get<GetPostPostsPostIdGetResponses, GetPostPostsPostIdGetErrors, ThrowOnError>({
    url: '/posts/{post_id}',
    ...options,
  })

/**
 * Update Post
 */
export const updatePostPostsPostIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePostPostsPostIdPutData, ThrowOnError>,
): RequestResult<UpdatePostPostsPostIdPutResponses, UpdatePostPostsPostIdPutErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdatePostPostsPostIdPutResponses, UpdatePostPostsPostIdPutErrors, ThrowOnError>({
    url: '/posts/{post_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Toggle Like Post
 */
export const toggleLikePostPostsPostIdToggleLikePost = <ThrowOnError extends boolean = false>(
  options: Options<ToggleLikePostPostsPostIdToggleLikePostData, ThrowOnError>,
): RequestResult<
  ToggleLikePostPostsPostIdToggleLikePostResponses,
  ToggleLikePostPostsPostIdToggleLikePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ToggleLikePostPostsPostIdToggleLikePostResponses,
    ToggleLikePostPostsPostIdToggleLikePostErrors,
    ThrowOnError
  >({ url: '/posts/{post_id}/toggle_like', ...options })

/**
 * Get Questions
 */
export const getQuestionsQuestionsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetQuestionsQuestionsGetData, ThrowOnError>,
): RequestResult<GetQuestionsQuestionsGetResponses, GetQuestionsQuestionsGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetQuestionsQuestionsGetResponses, GetQuestionsQuestionsGetErrors, ThrowOnError>({
    url: '/questions',
    ...options,
  })

/**
 * Create Question
 */
export const createQuestionQuestionsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateQuestionQuestionsPostData, ThrowOnError>,
): RequestResult<CreateQuestionQuestionsPostResponses, CreateQuestionQuestionsPostErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateQuestionQuestionsPostResponses,
    CreateQuestionQuestionsPostErrors,
    ThrowOnError
  >({
    url: '/questions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Question
 */
export const deleteQuestionQuestionsQuestionsIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteQuestionQuestionsQuestionsIdDeleteData, ThrowOnError>,
): RequestResult<
  DeleteQuestionQuestionsQuestionsIdDeleteResponses,
  DeleteQuestionQuestionsQuestionsIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteQuestionQuestionsQuestionsIdDeleteResponses,
    DeleteQuestionQuestionsQuestionsIdDeleteErrors,
    ThrowOnError
  >({ url: '/questions/{questions_id}', ...options })

/**
 * Update Question
 */
export const updateQuestionQuestionsQuestionsIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateQuestionQuestionsQuestionsIdPutData, ThrowOnError>,
): RequestResult<
  UpdateQuestionQuestionsQuestionsIdPutResponses,
  UpdateQuestionQuestionsQuestionsIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateQuestionQuestionsQuestionsIdPutResponses,
    UpdateQuestionQuestionsQuestionsIdPutErrors,
    ThrowOnError
  >({
    url: '/questions/{questions_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Users Near Birthdays
 */
export const getUsersNearBirthdaysUsersNearBirthdaysGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersNearBirthdaysUsersNearBirthdaysGetData, ThrowOnError>,
): RequestResult<
  GetUsersNearBirthdaysUsersNearBirthdaysGetResponses,
  GetUsersNearBirthdaysUsersNearBirthdaysGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsersNearBirthdaysUsersNearBirthdaysGetResponses,
    GetUsersNearBirthdaysUsersNearBirthdaysGetErrors,
    ThrowOnError
  >({ url: '/users/near_birthdays', ...options })

/**
 * Set User Role
 */
export const setUserRoleUsersUserIdRolePut = <ThrowOnError extends boolean = false>(
  options: Options<SetUserRoleUsersUserIdRolePutData, ThrowOnError>,
): RequestResult<SetUserRoleUsersUserIdRolePutResponses, SetUserRoleUsersUserIdRolePutErrors, ThrowOnError> =>
  (options.client ?? client).put<
    SetUserRoleUsersUserIdRolePutResponses,
    SetUserRoleUsersUserIdRolePutErrors,
    ThrowOnError
  >({
    url: '/users/{user_id}/role',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Set User Avatar
 */
export const setUserAvatarUsersUserIdAvatarPut = <ThrowOnError extends boolean = false>(
  options: Options<SetUserAvatarUsersUserIdAvatarPutData, ThrowOnError>,
): RequestResult<SetUserAvatarUsersUserIdAvatarPutResponses, SetUserAvatarUsersUserIdAvatarPutErrors, ThrowOnError> =>
  (options.client ?? client).put<
    SetUserAvatarUsersUserIdAvatarPutResponses,
    SetUserAvatarUsersUserIdAvatarPutErrors,
    ThrowOnError
  >({
    url: '/users/{user_id}/avatar',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List User Profiles Page
 */
export const listUserProfilesPagePassportIdmIdmListUserProfilesPagePost = <ThrowOnError extends boolean = false>(
  options: Options<ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostData, ThrowOnError>,
): RequestResult<
  ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostResponses,
  ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostResponses,
    ListUserProfilesPagePassportIdmIdmListUserProfilesPagePostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.Idm/ListUserProfilesPage',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List User Profiles Full Page
 */
export const listUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostData, ThrowOnError>,
): RequestResult<
  ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostResponses,
  ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostResponses,
    ListUserProfilesFullPagePassportIdmIdmListUserProfilesFullPagePostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.Idm/ListUserProfilesFullPage',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Current User Profile
 */
export const getCurrentUserProfilePassportIdmIdmGetCurrentUserPost = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostData, ThrowOnError>,
): RequestResult<
  GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostResponses,
  GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostResponses,
    GetCurrentUserProfilePassportIdmIdmGetCurrentUserPostErrors,
    ThrowOnError
  >({ url: '/passport.idm.Idm/GetCurrentUser', ...options })

/**
 * Get Product Tags
 */
export const getProductTagsShopProductsTagsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetProductTagsShopProductsTagsGetData, ThrowOnError>,
): RequestResult<GetProductTagsShopProductsTagsGetResponses, GetProductTagsShopProductsTagsGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetProductTagsShopProductsTagsGetResponses,
    GetProductTagsShopProductsTagsGetErrors,
    ThrowOnError
  >({ url: '/shop/products/tags', ...options })

/**
 * Create Product Tag
 */
export const createProductTagShopProductsTagsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateProductTagShopProductsTagsPostData, ThrowOnError>,
): RequestResult<
  CreateProductTagShopProductsTagsPostResponses,
  CreateProductTagShopProductsTagsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateProductTagShopProductsTagsPostResponses,
    CreateProductTagShopProductsTagsPostErrors,
    ThrowOnError
  >({
    url: '/shop/products/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Product Tag
 */
export const deleteProductTagShopProductsTagsProductTagIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProductTagShopProductsTagsProductTagIdDeleteData, ThrowOnError>,
): RequestResult<
  DeleteProductTagShopProductsTagsProductTagIdDeleteResponses,
  DeleteProductTagShopProductsTagsProductTagIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteProductTagShopProductsTagsProductTagIdDeleteResponses,
    DeleteProductTagShopProductsTagsProductTagIdDeleteErrors,
    ThrowOnError
  >({ url: '/shop/products/tags/{product_tag_id}', ...options })

/**
 * Update Product Tag
 */
export const updateProductTagShopProductsTagsProductTagIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProductTagShopProductsTagsProductTagIdPutData, ThrowOnError>,
): RequestResult<
  UpdateProductTagShopProductsTagsProductTagIdPutResponses,
  UpdateProductTagShopProductsTagsProductTagIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateProductTagShopProductsTagsProductTagIdPutResponses,
    UpdateProductTagShopProductsTagsProductTagIdPutErrors,
    ThrowOnError
  >({
    url: '/shop/products/tags/{product_tag_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Product Labels
 */
export const listProductLabelsShopProductsLabelsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListProductLabelsShopProductsLabelsGetData, ThrowOnError>,
): RequestResult<
  ListProductLabelsShopProductsLabelsGetResponses,
  ListProductLabelsShopProductsLabelsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ListProductLabelsShopProductsLabelsGetResponses,
    ListProductLabelsShopProductsLabelsGetErrors,
    ThrowOnError
  >({ url: '/shop/products/labels', ...options })

/**
 * Create Product Label
 */
export const createProductLabelShopProductsLabelsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateProductLabelShopProductsLabelsPostData, ThrowOnError>,
): RequestResult<
  CreateProductLabelShopProductsLabelsPostResponses,
  CreateProductLabelShopProductsLabelsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateProductLabelShopProductsLabelsPostResponses,
    CreateProductLabelShopProductsLabelsPostErrors,
    ThrowOnError
  >({
    url: '/shop/products/labels',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Product Label
 */
export const deleteProductLabelShopProductsLabelsProductLabelIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProductLabelShopProductsLabelsProductLabelIdDeleteData, ThrowOnError>,
): RequestResult<
  DeleteProductLabelShopProductsLabelsProductLabelIdDeleteResponses,
  DeleteProductLabelShopProductsLabelsProductLabelIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteProductLabelShopProductsLabelsProductLabelIdDeleteResponses,
    DeleteProductLabelShopProductsLabelsProductLabelIdDeleteErrors,
    ThrowOnError
  >({ url: '/shop/products/labels/{product_label_id}', ...options })

/**
 * Update Product Label
 */
export const updateProductLabelShopProductsLabelsProductLabelIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProductLabelShopProductsLabelsProductLabelIdPutData, ThrowOnError>,
): RequestResult<
  UpdateProductLabelShopProductsLabelsProductLabelIdPutResponses,
  UpdateProductLabelShopProductsLabelsProductLabelIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateProductLabelShopProductsLabelsProductLabelIdPutResponses,
    UpdateProductLabelShopProductsLabelsProductLabelIdPutErrors,
    ThrowOnError
  >({
    url: '/shop/products/labels/{product_label_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create Product Review
 */
export const createProductReviewShopOrdersOrderIdProductsProductIdReviewsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostData, ThrowOnError>,
): RequestResult<
  CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostResponses,
  CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostResponses,
    CreateProductReviewShopOrdersOrderIdProductsProductIdReviewsPostErrors,
    ThrowOnError
  >({
    url: '/shop/orders/{order_id}/products/{product_id}/reviews',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Product Reviews
 */
export const listProductReviewsShopProductsProductIdReviewsGet = <ThrowOnError extends boolean = false>(
  options: Options<ListProductReviewsShopProductsProductIdReviewsGetData, ThrowOnError>,
): RequestResult<
  ListProductReviewsShopProductsProductIdReviewsGetResponses,
  ListProductReviewsShopProductsProductIdReviewsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ListProductReviewsShopProductsProductIdReviewsGetResponses,
    ListProductReviewsShopProductsProductIdReviewsGetErrors,
    ThrowOnError
  >({ url: '/shop/products/{product_id}/reviews', ...options })

/**
 * List Reviews Admin
 */
export const listReviewsAdminShopReviewsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListReviewsAdminShopReviewsGetData, ThrowOnError>,
): RequestResult<ListReviewsAdminShopReviewsGetResponses, ListReviewsAdminShopReviewsGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ListReviewsAdminShopReviewsGetResponses,
    ListReviewsAdminShopReviewsGetErrors,
    ThrowOnError
  >({ url: '/shop/reviews', ...options })

/**
 * Get Review Admin
 */
export const getReviewAdminShopReviewsReviewIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetReviewAdminShopReviewsReviewIdGetData, ThrowOnError>,
): RequestResult<
  GetReviewAdminShopReviewsReviewIdGetResponses,
  GetReviewAdminShopReviewsReviewIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetReviewAdminShopReviewsReviewIdGetResponses,
    GetReviewAdminShopReviewsReviewIdGetErrors,
    ThrowOnError
  >({ url: '/shop/reviews/{review_id}', ...options })

/**
 * Approve Product Review
 */
export const approveProductReviewShopReviewsReviewIdApprovePut = <ThrowOnError extends boolean = false>(
  options: Options<ApproveProductReviewShopReviewsReviewIdApprovePutData, ThrowOnError>,
): RequestResult<
  ApproveProductReviewShopReviewsReviewIdApprovePutResponses,
  ApproveProductReviewShopReviewsReviewIdApprovePutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ApproveProductReviewShopReviewsReviewIdApprovePutResponses,
    ApproveProductReviewShopReviewsReviewIdApprovePutErrors,
    ThrowOnError
  >({ url: '/shop/reviews/{review_id}/approve', ...options })

/**
 * Reject Product Review
 */
export const rejectProductReviewShopReviewsReviewIdRejectPut = <ThrowOnError extends boolean = false>(
  options: Options<RejectProductReviewShopReviewsReviewIdRejectPutData, ThrowOnError>,
): RequestResult<
  RejectProductReviewShopReviewsReviewIdRejectPutResponses,
  RejectProductReviewShopReviewsReviewIdRejectPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    RejectProductReviewShopReviewsReviewIdRejectPutResponses,
    RejectProductReviewShopReviewsReviewIdRejectPutErrors,
    ThrowOnError
  >({ url: '/shop/reviews/{review_id}/reject', ...options })

/**
 * Get Products
 */
export const getProductsShopProductsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetProductsShopProductsGetData, ThrowOnError>,
): RequestResult<GetProductsShopProductsGetResponses, GetProductsShopProductsGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetProductsShopProductsGetResponses, GetProductsShopProductsGetErrors, ThrowOnError>({
    url: '/shop/products',
    ...options,
  })

/**
 * Create Product
 */
export const createProductShopProductsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateProductShopProductsPostData, ThrowOnError>,
): RequestResult<CreateProductShopProductsPostResponses, CreateProductShopProductsPostErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CreateProductShopProductsPostResponses,
    CreateProductShopProductsPostErrors,
    ThrowOnError
  >({
    url: '/shop/products',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Product
 */
export const deleteProductShopProductsProductIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProductShopProductsProductIdDeleteData, ThrowOnError>,
): RequestResult<
  DeleteProductShopProductsProductIdDeleteResponses,
  DeleteProductShopProductsProductIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteProductShopProductsProductIdDeleteResponses,
    DeleteProductShopProductsProductIdDeleteErrors,
    ThrowOnError
  >({ url: '/shop/products/{product_id}', ...options })

/**
 * Get Product
 */
export const getProductShopProductsProductIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetProductShopProductsProductIdGetData, ThrowOnError>,
): RequestResult<GetProductShopProductsProductIdGetResponses, GetProductShopProductsProductIdGetErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetProductShopProductsProductIdGetResponses,
    GetProductShopProductsProductIdGetErrors,
    ThrowOnError
  >({ url: '/shop/products/{product_id}', ...options })

/**
 * Update Product
 */
export const updateProductShopProductsProductIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProductShopProductsProductIdPutData, ThrowOnError>,
): RequestResult<
  UpdateProductShopProductsProductIdPutResponses,
  UpdateProductShopProductsProductIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateProductShopProductsProductIdPutResponses,
    UpdateProductShopProductsProductIdPutErrors,
    ThrowOnError
  >({
    url: '/shop/products/{product_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Product Stock
 */
export const updateProductStockShopProductsProductIdStockPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProductStockShopProductsProductIdStockPutData, ThrowOnError>,
): RequestResult<
  UpdateProductStockShopProductsProductIdStockPutResponses,
  UpdateProductStockShopProductsProductIdStockPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateProductStockShopProductsProductIdStockPutResponses,
    UpdateProductStockShopProductsProductIdStockPutErrors,
    ThrowOnError
  >({
    url: '/shop/products/{product_id}/stock',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Export Stock Excel
 */
export const exportStockExcelShopExportStockGet = <ThrowOnError extends boolean = false>(
  options?: Options<ExportStockExcelShopExportStockGetData, ThrowOnError>,
): RequestResult<ExportStockExcelShopExportStockGetResponses, ExportStockExcelShopExportStockGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ExportStockExcelShopExportStockGetResponses,
    ExportStockExcelShopExportStockGetErrors,
    ThrowOnError
  >({ url: '/shop/export-stock', ...options })

/**
 * Restore Product
 */
export const restoreProductShopProductsProductIdRestorePut = <ThrowOnError extends boolean = false>(
  options: Options<RestoreProductShopProductsProductIdRestorePutData, ThrowOnError>,
): RequestResult<
  RestoreProductShopProductsProductIdRestorePutResponses,
  RestoreProductShopProductsProductIdRestorePutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    RestoreProductShopProductsProductIdRestorePutResponses,
    RestoreProductShopProductsProductIdRestorePutErrors,
    ThrowOnError
  >({ url: '/shop/products/{product_id}/restore', ...options })

/**
 * Get Delivery Address
 */
export const getDeliveryAddressShopDeliveryAddressUserIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetDeliveryAddressShopDeliveryAddressUserIdGetData, ThrowOnError>,
): RequestResult<
  GetDeliveryAddressShopDeliveryAddressUserIdGetResponses,
  GetDeliveryAddressShopDeliveryAddressUserIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetDeliveryAddressShopDeliveryAddressUserIdGetResponses,
    GetDeliveryAddressShopDeliveryAddressUserIdGetErrors,
    ThrowOnError
  >({ url: '/shop/delivery-address/{user_id}', ...options })

/**
 * Upsert Delivery Address
 */
export const upsertDeliveryAddressShopDeliveryAddressUserIdPost = <ThrowOnError extends boolean = false>(
  options: Options<UpsertDeliveryAddressShopDeliveryAddressUserIdPostData, ThrowOnError>,
): RequestResult<
  UpsertDeliveryAddressShopDeliveryAddressUserIdPostResponses,
  UpsertDeliveryAddressShopDeliveryAddressUserIdPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpsertDeliveryAddressShopDeliveryAddressUserIdPostResponses,
    UpsertDeliveryAddressShopDeliveryAddressUserIdPostErrors,
    ThrowOnError
  >({
    url: '/shop/delivery-address/{user_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Orders
 */
export const getOrdersShopOrdersGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrdersShopOrdersGetData, ThrowOnError>,
): RequestResult<GetOrdersShopOrdersGetResponses, GetOrdersShopOrdersGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetOrdersShopOrdersGetResponses, GetOrdersShopOrdersGetErrors, ThrowOnError>({
    url: '/shop/orders',
    ...options,
  })

/**
 * Buy Product
 */
export const buyProductShopOrdersPost = <ThrowOnError extends boolean = false>(
  options: Options<BuyProductShopOrdersPostData, ThrowOnError>,
): RequestResult<BuyProductShopOrdersPostResponses, BuyProductShopOrdersPostErrors, ThrowOnError> =>
  (options.client ?? client).post<BuyProductShopOrdersPostResponses, BuyProductShopOrdersPostErrors, ThrowOnError>({
    url: '/shop/orders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Export Orders Excel
 */
export const exportOrdersExcelShopOrdersExportGet = <ThrowOnError extends boolean = false>(
  options: Options<ExportOrdersExcelShopOrdersExportGetData, ThrowOnError>,
): RequestResult<
  ExportOrdersExcelShopOrdersExportGetResponses,
  ExportOrdersExcelShopOrdersExportGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ExportOrdersExcelShopOrdersExportGetResponses,
    ExportOrdersExcelShopOrdersExportGetErrors,
    ThrowOnError
  >({ url: '/shop/orders/export', ...options })

/**
 * Get Order States
 */
export const getOrderStatesShopOrdersOrderIdStatesGet = <ThrowOnError extends boolean = false>(
  options: Options<GetOrderStatesShopOrdersOrderIdStatesGetData, ThrowOnError>,
): RequestResult<
  GetOrderStatesShopOrdersOrderIdStatesGetResponses,
  GetOrderStatesShopOrdersOrderIdStatesGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetOrderStatesShopOrdersOrderIdStatesGetResponses,
    GetOrderStatesShopOrdersOrderIdStatesGetErrors,
    ThrowOnError
  >({ url: '/shop/orders/{order_id}/states', ...options })

/**
 * Set Order State
 */
export const setOrderStateShopOrdersOrderIdStatesPost = <ThrowOnError extends boolean = false>(
  options: Options<SetOrderStateShopOrdersOrderIdStatesPostData, ThrowOnError>,
): RequestResult<
  SetOrderStateShopOrdersOrderIdStatesPostResponses,
  SetOrderStateShopOrdersOrderIdStatesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SetOrderStateShopOrdersOrderIdStatesPostResponses,
    SetOrderStateShopOrdersOrderIdStatesPostErrors,
    ThrowOnError
  >({
    url: '/shop/orders/{order_id}/states',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Set Order Track Code
 */
export const setOrderTrackCodeShopOrdersOrderIdTrackCodePost = <ThrowOnError extends boolean = false>(
  options: Options<SetOrderTrackCodeShopOrdersOrderIdTrackCodePostData, ThrowOnError>,
): RequestResult<
  SetOrderTrackCodeShopOrdersOrderIdTrackCodePostResponses,
  SetOrderTrackCodeShopOrdersOrderIdTrackCodePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    SetOrderTrackCodeShopOrdersOrderIdTrackCodePostResponses,
    SetOrderTrackCodeShopOrdersOrderIdTrackCodePostErrors,
    ThrowOnError
  >({
    url: '/shop/orders/{order_id}/track-code',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Cancel Order
 */
export const cancelOrderShopOrdersOrderIdCancelPost = <ThrowOnError extends boolean = false>(
  options: Options<CancelOrderShopOrdersOrderIdCancelPostData, ThrowOnError>,
): RequestResult<
  CancelOrderShopOrdersOrderIdCancelPostResponses,
  CancelOrderShopOrdersOrderIdCancelPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CancelOrderShopOrdersOrderIdCancelPostResponses,
    CancelOrderShopOrdersOrderIdCancelPostErrors,
    ThrowOnError
  >({ url: '/shop/orders/{order_id}/cancel', ...options })

/**
 * Get Balance
 */
export const getBalanceAccountBalanceGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetBalanceAccountBalanceGetData, ThrowOnError>,
): RequestResult<GetBalanceAccountBalanceGetResponses, GetBalanceAccountBalanceGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetBalanceAccountBalanceGetResponses,
    GetBalanceAccountBalanceGetErrors,
    ThrowOnError
  >({ url: '/account/balance', ...options })

/**
 * Get Users Balance
 */
export const getUsersBalanceAccountBalanceUsersGet = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersBalanceAccountBalanceUsersGetData, ThrowOnError>,
): RequestResult<
  GetUsersBalanceAccountBalanceUsersGetResponses,
  GetUsersBalanceAccountBalanceUsersGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUsersBalanceAccountBalanceUsersGetResponses,
    GetUsersBalanceAccountBalanceUsersGetErrors,
    ThrowOnError
  >({ url: '/account/balance/users', ...options })

/**
 * Get User Balance
 */
export const getUserBalanceAccountBalanceUserUserIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetUserBalanceAccountBalanceUserUserIdGetData, ThrowOnError>,
): RequestResult<
  GetUserBalanceAccountBalanceUserUserIdGetResponses,
  GetUserBalanceAccountBalanceUserUserIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetUserBalanceAccountBalanceUserUserIdGetResponses,
    GetUserBalanceAccountBalanceUserUserIdGetErrors,
    ThrowOnError
  >({ url: '/account/balance/user/{user_id}', ...options })

/**
 * Get History
 */
export const getHistoryAccountHistoryGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetHistoryAccountHistoryGetData, ThrowOnError>,
): RequestResult<GetHistoryAccountHistoryGetResponses, GetHistoryAccountHistoryGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetHistoryAccountHistoryGetResponses,
    GetHistoryAccountHistoryGetErrors,
    ThrowOnError
  >({ url: '/account/history', ...options })

/**
 * Transfer Coins
 */
export const transferCoinsAccountBalanceTransferPost = <ThrowOnError extends boolean = false>(
  options: Options<TransferCoinsAccountBalanceTransferPostData, ThrowOnError>,
): RequestResult<
  TransferCoinsAccountBalanceTransferPostResponses,
  TransferCoinsAccountBalanceTransferPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    TransferCoinsAccountBalanceTransferPostResponses,
    TransferCoinsAccountBalanceTransferPostErrors,
    ThrowOnError
  >({
    url: '/account/balance/transfer',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Add Coins
 */
export const addCoinsAccountBalanceAddPost = <ThrowOnError extends boolean = false>(
  options: Options<AddCoinsAccountBalanceAddPostData, ThrowOnError>,
): RequestResult<AddCoinsAccountBalanceAddPostResponses, AddCoinsAccountBalanceAddPostErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AddCoinsAccountBalanceAddPostResponses,
    AddCoinsAccountBalanceAddPostErrors,
    ThrowOnError
  >({
    url: '/account/balance/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Debit Coins
 */
export const debitCoinsAccountBalanceDebitPost = <ThrowOnError extends boolean = false>(
  options: Options<DebitCoinsAccountBalanceDebitPostData, ThrowOnError>,
): RequestResult<DebitCoinsAccountBalanceDebitPostResponses, DebitCoinsAccountBalanceDebitPostErrors, ThrowOnError> =>
  (options.client ?? client).post<
    DebitCoinsAccountBalanceDebitPostResponses,
    DebitCoinsAccountBalanceDebitPostErrors,
    ThrowOnError
  >({
    url: '/account/balance/debit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Bulk Add Coins
 */
export const bulkAddCoinsAccountBalanceBulkAddPost = <ThrowOnError extends boolean = false>(
  options: Options<BulkAddCoinsAccountBalanceBulkAddPostData, ThrowOnError>,
): RequestResult<
  BulkAddCoinsAccountBalanceBulkAddPostResponses,
  BulkAddCoinsAccountBalanceBulkAddPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BulkAddCoinsAccountBalanceBulkAddPostResponses,
    BulkAddCoinsAccountBalanceBulkAddPostErrors,
    ThrowOnError
  >({
    url: '/account/balance/bulk-add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Import Validate
 */
export const importValidateAccountBalanceImportValidatePost = <ThrowOnError extends boolean = false>(
  options: Options<ImportValidateAccountBalanceImportValidatePostData, ThrowOnError>,
): RequestResult<
  ImportValidateAccountBalanceImportValidatePostResponses,
  ImportValidateAccountBalanceImportValidatePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ImportValidateAccountBalanceImportValidatePostResponses,
    ImportValidateAccountBalanceImportValidatePostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/account/balance/import/validate',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })

/**
 * Import Confirm
 */
export const importConfirmAccountBalanceImportConfirmPost = <ThrowOnError extends boolean = false>(
  options: Options<ImportConfirmAccountBalanceImportConfirmPostData, ThrowOnError>,
): RequestResult<
  ImportConfirmAccountBalanceImportConfirmPostResponses,
  ImportConfirmAccountBalanceImportConfirmPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ImportConfirmAccountBalanceImportConfirmPostResponses,
    ImportConfirmAccountBalanceImportConfirmPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/account/balance/import/confirm',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })

/**
 * Get Journal
 */
export const getJournalAccountJournalGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetJournalAccountJournalGetData, ThrowOnError>,
): RequestResult<GetJournalAccountJournalGetResponses, GetJournalAccountJournalGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetJournalAccountJournalGetResponses,
    GetJournalAccountJournalGetErrors,
    ThrowOnError
  >({ url: '/account/journal', ...options })

/**
 * Export Journal
 */
export const exportJournalAccountJournalExportGet = <ThrowOnError extends boolean = false>(
  options?: Options<ExportJournalAccountJournalExportGetData, ThrowOnError>,
): RequestResult<
  ExportJournalAccountJournalExportGetResponses,
  ExportJournalAccountJournalExportGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    ExportJournalAccountJournalExportGetResponses,
    ExportJournalAccountJournalExportGetErrors,
    ThrowOnError
  >({ url: '/account/journal/export', ...options })

/**
 * Get Journal Detail
 */
export const getJournalDetailAccountJournalJournalRecordIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetJournalDetailAccountJournalJournalRecordIdGetData, ThrowOnError>,
): RequestResult<
  GetJournalDetailAccountJournalJournalRecordIdGetResponses,
  GetJournalDetailAccountJournalJournalRecordIdGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetJournalDetailAccountJournalJournalRecordIdGetResponses,
    GetJournalDetailAccountJournalJournalRecordIdGetErrors,
    ThrowOnError
  >({ url: '/account/journal/{journal_record_id}', ...options })

/**
 * Get Import Template
 */
export const getImportTemplateAccountBalanceImportTemplateGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetImportTemplateAccountBalanceImportTemplateGetData, ThrowOnError>,
): RequestResult<
  GetImportTemplateAccountBalanceImportTemplateGetResponses,
  GetImportTemplateAccountBalanceImportTemplateGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetImportTemplateAccountBalanceImportTemplateGetResponses,
    GetImportTemplateAccountBalanceImportTemplateGetErrors,
    ThrowOnError
  >({ url: '/account/balance/import/template', ...options })

/**
 * Get Feedback Category Emails
 */
export const getFeedbackCategoryEmailsFeedbackCategoriesEmailsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetData, ThrowOnError>,
): RequestResult<
  GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetResponses,
  GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetResponses,
    GetFeedbackCategoryEmailsFeedbackCategoriesEmailsGetErrors,
    ThrowOnError
  >({ url: '/feedback/categories/emails', ...options })

/**
 * Set Feedback Category Emails
 */
export const setFeedbackCategoryEmailsFeedbackCategoriesEmailsPut = <ThrowOnError extends boolean = false>(
  options: Options<SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutData, ThrowOnError>,
): RequestResult<
  SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutResponses,
  SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutResponses,
    SetFeedbackCategoryEmailsFeedbackCategoriesEmailsPutErrors,
    ThrowOnError
  >({
    url: '/feedback/categories/emails',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Feedback Categories
 */
export const getFeedbackCategoriesFeedbackCategoriesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeedbackCategoriesFeedbackCategoriesGetData, ThrowOnError>,
): RequestResult<
  GetFeedbackCategoriesFeedbackCategoriesGetResponses,
  GetFeedbackCategoriesFeedbackCategoriesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetFeedbackCategoriesFeedbackCategoriesGetResponses,
    GetFeedbackCategoriesFeedbackCategoriesGetErrors,
    ThrowOnError
  >({ url: '/feedback/categories', ...options })

/**
 * Create Feedback Category
 */
export const createFeedbackCategoryFeedbackCategoriesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateFeedbackCategoryFeedbackCategoriesPostData, ThrowOnError>,
): RequestResult<
  CreateFeedbackCategoryFeedbackCategoriesPostResponses,
  CreateFeedbackCategoryFeedbackCategoriesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateFeedbackCategoryFeedbackCategoriesPostResponses,
    CreateFeedbackCategoryFeedbackCategoriesPostErrors,
    ThrowOnError
  >({
    url: '/feedback/categories',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Feedback Category
 */
export const deleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteData, ThrowOnError>,
): RequestResult<
  DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteResponses,
  DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteResponses,
    DeleteFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdDeleteErrors,
    ThrowOnError
  >({ url: '/feedback/categories/{feedback_category_id}', ...options })

/**
 * Update Feedback Category
 */
export const updateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutData, ThrowOnError>,
): RequestResult<
  UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutResponses,
  UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutResponses,
    UpdateFeedbackCategoryFeedbackCategoriesFeedbackCategoryIdPutErrors,
    ThrowOnError
  >({
    url: '/feedback/categories/{feedback_category_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Send Feedback
 */
export const sendFeedbackFeedbackSendPost = <ThrowOnError extends boolean = false>(
  options: Options<SendFeedbackFeedbackSendPostData, ThrowOnError>,
): RequestResult<SendFeedbackFeedbackSendPostResponses, SendFeedbackFeedbackSendPostErrors, ThrowOnError> =>
  (options.client ?? client).post<
    SendFeedbackFeedbackSendPostResponses,
    SendFeedbackFeedbackSendPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/feedback/send',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })

/**
 * Get Events
 */
export const getEventsEventsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetEventsEventsGetData, ThrowOnError>,
): RequestResult<GetEventsEventsGetResponses, GetEventsEventsGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetEventsEventsGetResponses, GetEventsEventsGetErrors, ThrowOnError>({
    url: '/events',
    ...options,
  })

/**
 * Create Event
 */
export const createEventEventsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateEventEventsPostData, ThrowOnError>,
): RequestResult<CreateEventEventsPostResponses, CreateEventEventsPostErrors, ThrowOnError> =>
  (options.client ?? client).post<CreateEventEventsPostResponses, CreateEventEventsPostErrors, ThrowOnError>({
    url: '/events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Event
 */
export const deleteEventEventsEventIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEventEventsEventIdDeleteData, ThrowOnError>,
): RequestResult<DeleteEventEventsEventIdDeleteResponses, DeleteEventEventsEventIdDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    DeleteEventEventsEventIdDeleteResponses,
    DeleteEventEventsEventIdDeleteErrors,
    ThrowOnError
  >({ url: '/events/{event_id}', ...options })

/**
 * Get Event
 */
export const getEventEventsEventIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetEventEventsEventIdGetData, ThrowOnError>,
): RequestResult<GetEventEventsEventIdGetResponses, GetEventEventsEventIdGetErrors, ThrowOnError> =>
  (options.client ?? client).get<GetEventEventsEventIdGetResponses, GetEventEventsEventIdGetErrors, ThrowOnError>({
    url: '/events/{event_id}',
    ...options,
  })

/**
 * Update Event
 */
export const updateEventEventsEventIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEventEventsEventIdPutData, ThrowOnError>,
): RequestResult<UpdateEventEventsEventIdPutResponses, UpdateEventEventsEventIdPutErrors, ThrowOnError> =>
  (options.client ?? client).put<UpdateEventEventsEventIdPutResponses, UpdateEventEventsEventIdPutErrors, ThrowOnError>(
    {
      url: '/events/{event_id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )

/**
 * Get Brand Config
 */
export const getBrandConfigBrandingGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetBrandConfigBrandingGetData, ThrowOnError>,
): RequestResult<GetBrandConfigBrandingGetResponses, GetBrandConfigBrandingGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetBrandConfigBrandingGetResponses, GetBrandConfigBrandingGetErrors, ThrowOnError>({
    url: '/branding',
    ...options,
  })

/**
 * Update Brand Config
 */
export const updateBrandConfigBrandingPost = <ThrowOnError extends boolean = false>(
  options: Options<UpdateBrandConfigBrandingPostData, ThrowOnError>,
): RequestResult<UpdateBrandConfigBrandingPostResponses, UpdateBrandConfigBrandingPostErrors, ThrowOnError> =>
  (options.client ?? client).post<
    UpdateBrandConfigBrandingPostResponses,
    UpdateBrandConfigBrandingPostErrors,
    ThrowOnError
  >({
    url: '/branding',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create Department
 */
export const createDepartmentPassportIdmIdmPrivateCreateDepartmentPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostData, ThrowOnError>,
): RequestResult<
  CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostResponses,
  CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostResponses,
    CreateDepartmentPassportIdmIdmPrivateCreateDepartmentPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/CreateDepartment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Child Departments
 */
export const listChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPost = <ThrowOnError extends boolean = false>(
  options: Options<ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostData, ThrowOnError>,
): RequestResult<
  ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostResponses,
  ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostResponses,
    ListChildDepartmentsPassportIdmIdmPrivateListChildDepartmentsPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/ListChildDepartments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Department
 */
export const getDepartmentPassportIdmIdmPrivateGetDepartmentPost = <ThrowOnError extends boolean = false>(
  options: Options<GetDepartmentPassportIdmIdmPrivateGetDepartmentPostData, ThrowOnError>,
): RequestResult<
  GetDepartmentPassportIdmIdmPrivateGetDepartmentPostResponses,
  GetDepartmentPassportIdmIdmPrivateGetDepartmentPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetDepartmentPassportIdmIdmPrivateGetDepartmentPostResponses,
    GetDepartmentPassportIdmIdmPrivateGetDepartmentPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/GetDepartment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Departments
 */
export const listDepartmentsPassportIdmIdmPrivateListDepartmentsPost = <ThrowOnError extends boolean = false>(
  options: Options<ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostData, ThrowOnError>,
): RequestResult<
  ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostResponses,
  ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostResponses,
    ListDepartmentsPassportIdmIdmPrivateListDepartmentsPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/ListDepartments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Department
 */
export const deleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPost = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostData, ThrowOnError>,
): RequestResult<
  DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostResponses,
  DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostResponses,
    DeleteDepartmentPassportIdmIdmPrivateDeleteDepartmentPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/DeleteDepartment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Department
 */
export const updateDepartmentPassportIdmIdmPrivateUpdateDepartmentPost = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostData, ThrowOnError>,
): RequestResult<
  UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostResponses,
  UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostResponses,
    UpdateDepartmentPassportIdmIdmPrivateUpdateDepartmentPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/UpdateDepartment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Departments Tree
 */
export const getDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePost = <ThrowOnError extends boolean = false>(
  options?: Options<GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostData, ThrowOnError>,
): RequestResult<
  GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostResponses,
  GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostResponses,
    GetDepartmentsTreePassportIdmIdmPrivateGetDepartmentsTreePostErrors,
    ThrowOnError
  >({ url: '/passport.idm.IdmPrivate/GetDepartmentsTree', ...options })

/**
 * Get Department Breadcrumbs
 */
export const getDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostData, ThrowOnError>,
): RequestResult<
  GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostResponses,
  GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostResponses,
    GetDepartmentBreadcrumbsPassportIdmIdmPrivateGetDepartmentBreadcrumbsPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/GetDepartmentBreadcrumbs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create City
 */
export const createCityPassportIdmIdmPrivateCreateCityPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateCityPassportIdmIdmPrivateCreateCityPostData, ThrowOnError>,
): RequestResult<
  CreateCityPassportIdmIdmPrivateCreateCityPostResponses,
  CreateCityPassportIdmIdmPrivateCreateCityPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateCityPassportIdmIdmPrivateCreateCityPostResponses,
    CreateCityPassportIdmIdmPrivateCreateCityPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/CreateCity',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create Country
 */
export const createCountryPassportIdmIdmPrivateCreateCountryPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateCountryPassportIdmIdmPrivateCreateCountryPostData, ThrowOnError>,
): RequestResult<
  CreateCountryPassportIdmIdmPrivateCreateCountryPostResponses,
  CreateCountryPassportIdmIdmPrivateCreateCountryPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateCountryPassportIdmIdmPrivateCreateCountryPostResponses,
    CreateCountryPassportIdmIdmPrivateCreateCountryPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/CreateCountry',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create Office
 */
export const createOfficePassportIdmIdmPrivateCreateOfficePost = <ThrowOnError extends boolean = false>(
  options: Options<CreateOfficePassportIdmIdmPrivateCreateOfficePostData, ThrowOnError>,
): RequestResult<
  CreateOfficePassportIdmIdmPrivateCreateOfficePostResponses,
  CreateOfficePassportIdmIdmPrivateCreateOfficePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateOfficePassportIdmIdmPrivateCreateOfficePostResponses,
    CreateOfficePassportIdmIdmPrivateCreateOfficePostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/CreateOffice',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete City
 */
export const deleteCityPassportIdmIdmPrivateDeleteCityPost = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCityPassportIdmIdmPrivateDeleteCityPostData, ThrowOnError>,
): RequestResult<
  DeleteCityPassportIdmIdmPrivateDeleteCityPostResponses,
  DeleteCityPassportIdmIdmPrivateDeleteCityPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteCityPassportIdmIdmPrivateDeleteCityPostResponses,
    DeleteCityPassportIdmIdmPrivateDeleteCityPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/DeleteCity',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Country
 */
export const deleteCountryPassportIdmIdmPrivateDeleteCountryPost = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCountryPassportIdmIdmPrivateDeleteCountryPostData, ThrowOnError>,
): RequestResult<
  DeleteCountryPassportIdmIdmPrivateDeleteCountryPostResponses,
  DeleteCountryPassportIdmIdmPrivateDeleteCountryPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteCountryPassportIdmIdmPrivateDeleteCountryPostResponses,
    DeleteCountryPassportIdmIdmPrivateDeleteCountryPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/DeleteCountry',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Office
 */
export const deleteOfficePassportIdmIdmPrivateDeleteOfficePost = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOfficePassportIdmIdmPrivateDeleteOfficePostData, ThrowOnError>,
): RequestResult<
  DeleteOfficePassportIdmIdmPrivateDeleteOfficePostResponses,
  DeleteOfficePassportIdmIdmPrivateDeleteOfficePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeleteOfficePassportIdmIdmPrivateDeleteOfficePostResponses,
    DeleteOfficePassportIdmIdmPrivateDeleteOfficePostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/DeleteOffice',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get City
 */
export const getCityPassportIdmIdmPrivateGetCityPost = <ThrowOnError extends boolean = false>(
  options: Options<GetCityPassportIdmIdmPrivateGetCityPostData, ThrowOnError>,
): RequestResult<
  GetCityPassportIdmIdmPrivateGetCityPostResponses,
  GetCityPassportIdmIdmPrivateGetCityPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetCityPassportIdmIdmPrivateGetCityPostResponses,
    GetCityPassportIdmIdmPrivateGetCityPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/GetCity',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Country
 */
export const getCountryPassportIdmIdmPrivateGetCountryPost = <ThrowOnError extends boolean = false>(
  options: Options<GetCountryPassportIdmIdmPrivateGetCountryPostData, ThrowOnError>,
): RequestResult<
  GetCountryPassportIdmIdmPrivateGetCountryPostResponses,
  GetCountryPassportIdmIdmPrivateGetCountryPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetCountryPassportIdmIdmPrivateGetCountryPostResponses,
    GetCountryPassportIdmIdmPrivateGetCountryPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/GetCountry',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Office
 */
export const getOfficePassportIdmIdmPrivateGetOfficePost = <ThrowOnError extends boolean = false>(
  options: Options<GetOfficePassportIdmIdmPrivateGetOfficePostData, ThrowOnError>,
): RequestResult<
  GetOfficePassportIdmIdmPrivateGetOfficePostResponses,
  GetOfficePassportIdmIdmPrivateGetOfficePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetOfficePassportIdmIdmPrivateGetOfficePostResponses,
    GetOfficePassportIdmIdmPrivateGetOfficePostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/GetOffice',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Cities
 */
export const listCitiesPassportIdmIdmPrivateListCitiesPost = <ThrowOnError extends boolean = false>(
  options: Options<ListCitiesPassportIdmIdmPrivateListCitiesPostData, ThrowOnError>,
): RequestResult<
  ListCitiesPassportIdmIdmPrivateListCitiesPostResponses,
  ListCitiesPassportIdmIdmPrivateListCitiesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ListCitiesPassportIdmIdmPrivateListCitiesPostResponses,
    ListCitiesPassportIdmIdmPrivateListCitiesPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/ListCities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Countries
 */
export const listCountriesPassportIdmIdmPrivateListCountriesPost = <ThrowOnError extends boolean = false>(
  options: Options<ListCountriesPassportIdmIdmPrivateListCountriesPostData, ThrowOnError>,
): RequestResult<
  ListCountriesPassportIdmIdmPrivateListCountriesPostResponses,
  ListCountriesPassportIdmIdmPrivateListCountriesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ListCountriesPassportIdmIdmPrivateListCountriesPostResponses,
    ListCountriesPassportIdmIdmPrivateListCountriesPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/ListCountries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Offices
 */
export const listOfficesPassportIdmIdmPrivateListOfficesPost = <ThrowOnError extends boolean = false>(
  options: Options<ListOfficesPassportIdmIdmPrivateListOfficesPostData, ThrowOnError>,
): RequestResult<
  ListOfficesPassportIdmIdmPrivateListOfficesPostResponses,
  ListOfficesPassportIdmIdmPrivateListOfficesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ListOfficesPassportIdmIdmPrivateListOfficesPostResponses,
    ListOfficesPassportIdmIdmPrivateListOfficesPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/ListOffices',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update City
 */
export const updateCityPassportIdmIdmPrivateUpdateCityPost = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCityPassportIdmIdmPrivateUpdateCityPostData, ThrowOnError>,
): RequestResult<
  UpdateCityPassportIdmIdmPrivateUpdateCityPostResponses,
  UpdateCityPassportIdmIdmPrivateUpdateCityPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdateCityPassportIdmIdmPrivateUpdateCityPostResponses,
    UpdateCityPassportIdmIdmPrivateUpdateCityPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/UpdateCity',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Country
 */
export const updateCountryPassportIdmIdmPrivateUpdateCountryPost = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCountryPassportIdmIdmPrivateUpdateCountryPostData, ThrowOnError>,
): RequestResult<
  UpdateCountryPassportIdmIdmPrivateUpdateCountryPostResponses,
  UpdateCountryPassportIdmIdmPrivateUpdateCountryPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdateCountryPassportIdmIdmPrivateUpdateCountryPostResponses,
    UpdateCountryPassportIdmIdmPrivateUpdateCountryPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/UpdateCountry',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Office
 */
export const updateOfficePassportIdmIdmPrivateUpdateOfficePost = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOfficePassportIdmIdmPrivateUpdateOfficePostData, ThrowOnError>,
): RequestResult<
  UpdateOfficePassportIdmIdmPrivateUpdateOfficePostResponses,
  UpdateOfficePassportIdmIdmPrivateUpdateOfficePostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdateOfficePassportIdmIdmPrivateUpdateOfficePostResponses,
    UpdateOfficePassportIdmIdmPrivateUpdateOfficePostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/UpdateOffice',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Position
 */
export const getPositionPassportIdmIdmPrivateGetPositionPost = <ThrowOnError extends boolean = false>(
  options: Options<GetPositionPassportIdmIdmPrivateGetPositionPostData, ThrowOnError>,
): RequestResult<
  GetPositionPassportIdmIdmPrivateGetPositionPostResponses,
  GetPositionPassportIdmIdmPrivateGetPositionPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetPositionPassportIdmIdmPrivateGetPositionPostResponses,
    GetPositionPassportIdmIdmPrivateGetPositionPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/GetPosition',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Positions
 */
export const listPositionsPassportIdmIdmPrivateListPositionsPost = <ThrowOnError extends boolean = false>(
  options: Options<ListPositionsPassportIdmIdmPrivateListPositionsPostData, ThrowOnError>,
): RequestResult<
  ListPositionsPassportIdmIdmPrivateListPositionsPostResponses,
  ListPositionsPassportIdmIdmPrivateListPositionsPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ListPositionsPassportIdmIdmPrivateListPositionsPostResponses,
    ListPositionsPassportIdmIdmPrivateListPositionsPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/ListPositions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create Position
 */
export const createPositionPassportIdmIdmPrivateCreatePositionPost = <ThrowOnError extends boolean = false>(
  options: Options<CreatePositionPassportIdmIdmPrivateCreatePositionPostData, ThrowOnError>,
): RequestResult<
  CreatePositionPassportIdmIdmPrivateCreatePositionPostResponses,
  CreatePositionPassportIdmIdmPrivateCreatePositionPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreatePositionPassportIdmIdmPrivateCreatePositionPostResponses,
    CreatePositionPassportIdmIdmPrivateCreatePositionPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/CreatePosition',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Position
 */
export const updatePositionPassportIdmIdmPrivateUpdatePositionPost = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePositionPassportIdmIdmPrivateUpdatePositionPostData, ThrowOnError>,
): RequestResult<
  UpdatePositionPassportIdmIdmPrivateUpdatePositionPostResponses,
  UpdatePositionPassportIdmIdmPrivateUpdatePositionPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdatePositionPassportIdmIdmPrivateUpdatePositionPostResponses,
    UpdatePositionPassportIdmIdmPrivateUpdatePositionPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/UpdatePosition',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete Position
 */
export const deletePositionPassportIdmIdmPrivateDeletePositionPost = <ThrowOnError extends boolean = false>(
  options: Options<DeletePositionPassportIdmIdmPrivateDeletePositionPostData, ThrowOnError>,
): RequestResult<
  DeletePositionPassportIdmIdmPrivateDeletePositionPostResponses,
  DeletePositionPassportIdmIdmPrivateDeletePositionPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    DeletePositionPassportIdmIdmPrivateDeletePositionPostResponses,
    DeletePositionPassportIdmIdmPrivateDeletePositionPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/DeletePosition',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create User
 */
export const createUserPassportIdmIdmPrivateCreateUserPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserPassportIdmIdmPrivateCreateUserPostData, ThrowOnError>,
): RequestResult<
  CreateUserPassportIdmIdmPrivateCreateUserPostResponses,
  CreateUserPassportIdmIdmPrivateCreateUserPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    CreateUserPassportIdmIdmPrivateCreateUserPostResponses,
    CreateUserPassportIdmIdmPrivateCreateUserPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/CreateUser',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update User
 */
export const updateUserPassportIdmIdmPrivateUpdateUserPost = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserPassportIdmIdmPrivateUpdateUserPostData, ThrowOnError>,
): RequestResult<
  UpdateUserPassportIdmIdmPrivateUpdateUserPostResponses,
  UpdateUserPassportIdmIdmPrivateUpdateUserPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdateUserPassportIdmIdmPrivateUpdateUserPostResponses,
    UpdateUserPassportIdmIdmPrivateUpdateUserPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/UpdateUser',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Block User
 */
export const blockUserPassportIdmIdmPrivateBlockUserPost = <ThrowOnError extends boolean = false>(
  options: Options<BlockUserPassportIdmIdmPrivateBlockUserPostData, ThrowOnError>,
): RequestResult<
  BlockUserPassportIdmIdmPrivateBlockUserPostResponses,
  BlockUserPassportIdmIdmPrivateBlockUserPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    BlockUserPassportIdmIdmPrivateBlockUserPostResponses,
    BlockUserPassportIdmIdmPrivateBlockUserPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/BlockUser',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Unblock User
 */
export const unblockUserPassportIdmIdmPrivateUnblockUserPost = <ThrowOnError extends boolean = false>(
  options: Options<UnblockUserPassportIdmIdmPrivateUnblockUserPostData, ThrowOnError>,
): RequestResult<
  UnblockUserPassportIdmIdmPrivateUnblockUserPostResponses,
  UnblockUserPassportIdmIdmPrivateUnblockUserPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UnblockUserPassportIdmIdmPrivateUnblockUserPostResponses,
    UnblockUserPassportIdmIdmPrivateUnblockUserPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.IdmPrivate/UnblockUser',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Import Employees
 */
export const importEmployeesPassportIdmIdmPrivateImportEmployeesPost = <ThrowOnError extends boolean = false>(
  options: Options<ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostData, ThrowOnError>,
): RequestResult<
  ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostResponses,
  ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostResponses,
    ImportEmployeesPassportIdmIdmPrivateImportEmployeesPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/passport.idm.IdmPrivate/ImportEmployees',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })

/**
 * Get Import Template
 */
export const getImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetData, ThrowOnError>,
): RequestResult<
  GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetResponses,
  GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetResponses,
    GetImportTemplatePassportIdmIdmPrivateImportEmployeesTemplateGetErrors,
    ThrowOnError
  >({ url: '/passport.idm.IdmPrivate/ImportEmployees/Template', ...options })

/**
 * Get Tenant Bonuses Configs
 */
export const getTenantBonusesConfigsTenantBonusesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetTenantBonusesConfigsTenantBonusesGetData, ThrowOnError>,
): RequestResult<
  GetTenantBonusesConfigsTenantBonusesGetResponses,
  GetTenantBonusesConfigsTenantBonusesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetTenantBonusesConfigsTenantBonusesGetResponses,
    GetTenantBonusesConfigsTenantBonusesGetErrors,
    ThrowOnError
  >({ url: '/tenant/bonuses', ...options })

/**
 * Update Tenant Refills Config
 */
export const updateTenantRefillsConfigTenantBonusesPost = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTenantRefillsConfigTenantBonusesPostData, ThrowOnError>,
): RequestResult<
  UpdateTenantRefillsConfigTenantBonusesPostResponses,
  UpdateTenantRefillsConfigTenantBonusesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdateTenantRefillsConfigTenantBonusesPostResponses,
    UpdateTenantRefillsConfigTenantBonusesPostErrors,
    ThrowOnError
  >({
    url: '/tenant/bonuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Tenant Services Config
 */
export const getTenantServicesConfigTenantServicesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetTenantServicesConfigTenantServicesGetData, ThrowOnError>,
): RequestResult<
  GetTenantServicesConfigTenantServicesGetResponses,
  GetTenantServicesConfigTenantServicesGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetTenantServicesConfigTenantServicesGetResponses,
    GetTenantServicesConfigTenantServicesGetErrors,
    ThrowOnError
  >({ url: '/tenant/services', ...options })

/**
 * Update Tenant Services Config
 */
export const updateTenantServicesConfigTenantServicesPost = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTenantServicesConfigTenantServicesPostData, ThrowOnError>,
): RequestResult<
  UpdateTenantServicesConfigTenantServicesPostResponses,
  UpdateTenantServicesConfigTenantServicesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdateTenantServicesConfigTenantServicesPostResponses,
    UpdateTenantServicesConfigTenantServicesPostErrors,
    ThrowOnError
  >({
    url: '/tenant/services',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Tenant Portal Config
 */
export const getTenantPortalConfigTenantPortalGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetTenantPortalConfigTenantPortalGetData, ThrowOnError>,
): RequestResult<
  GetTenantPortalConfigTenantPortalGetResponses,
  GetTenantPortalConfigTenantPortalGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetTenantPortalConfigTenantPortalGetResponses,
    GetTenantPortalConfigTenantPortalGetErrors,
    ThrowOnError
  >({ url: '/tenant/portal', ...options })

/**
 * Update Tenant Portal Config
 */
export const updateTenantPortalConfigTenantPortalPost = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTenantPortalConfigTenantPortalPostData, ThrowOnError>,
): RequestResult<
  UpdateTenantPortalConfigTenantPortalPostResponses,
  UpdateTenantPortalConfigTenantPortalPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UpdateTenantPortalConfigTenantPortalPostResponses,
    UpdateTenantPortalConfigTenantPortalPostErrors,
    ThrowOnError
  >({
    url: '/tenant/portal',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get City Info
 */
export const getCityInfoPassportIdmIdmGetCityInfoPost = <ThrowOnError extends boolean = false>(
  options: Options<GetCityInfoPassportIdmIdmGetCityInfoPostData, ThrowOnError>,
): RequestResult<
  GetCityInfoPassportIdmIdmGetCityInfoPostResponses,
  GetCityInfoPassportIdmIdmGetCityInfoPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetCityInfoPassportIdmIdmGetCityInfoPostResponses,
    GetCityInfoPassportIdmIdmGetCityInfoPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.Idm/GetCityInfo',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Country Info
 */
export const getCountryInfoPassportIdmIdmGetCountryInfoPost = <ThrowOnError extends boolean = false>(
  options: Options<GetCountryInfoPassportIdmIdmGetCountryInfoPostData, ThrowOnError>,
): RequestResult<
  GetCountryInfoPassportIdmIdmGetCountryInfoPostResponses,
  GetCountryInfoPassportIdmIdmGetCountryInfoPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetCountryInfoPassportIdmIdmGetCountryInfoPostResponses,
    GetCountryInfoPassportIdmIdmGetCountryInfoPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.Idm/GetCountryInfo',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Office Info
 */
export const getOfficeInfoPassportIdmIdmGetOfficeInfoPost = <ThrowOnError extends boolean = false>(
  options: Options<GetOfficeInfoPassportIdmIdmGetOfficeInfoPostData, ThrowOnError>,
): RequestResult<
  GetOfficeInfoPassportIdmIdmGetOfficeInfoPostResponses,
  GetOfficeInfoPassportIdmIdmGetOfficeInfoPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    GetOfficeInfoPassportIdmIdmGetOfficeInfoPostResponses,
    GetOfficeInfoPassportIdmIdmGetOfficeInfoPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.Idm/GetOfficeInfo',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Cities Info
 */
export const listCitiesInfoPassportIdmIdmListCitiesInfoPost = <ThrowOnError extends boolean = false>(
  options: Options<ListCitiesInfoPassportIdmIdmListCitiesInfoPostData, ThrowOnError>,
): RequestResult<
  ListCitiesInfoPassportIdmIdmListCitiesInfoPostResponses,
  ListCitiesInfoPassportIdmIdmListCitiesInfoPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ListCitiesInfoPassportIdmIdmListCitiesInfoPostResponses,
    ListCitiesInfoPassportIdmIdmListCitiesInfoPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.Idm/ListCitiesInfo',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Countries Info
 */
export const listCountriesInfoPassportIdmIdmListCountriesInfoPost = <ThrowOnError extends boolean = false>(
  options: Options<ListCountriesInfoPassportIdmIdmListCountriesInfoPostData, ThrowOnError>,
): RequestResult<
  ListCountriesInfoPassportIdmIdmListCountriesInfoPostResponses,
  ListCountriesInfoPassportIdmIdmListCountriesInfoPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ListCountriesInfoPassportIdmIdmListCountriesInfoPostResponses,
    ListCountriesInfoPassportIdmIdmListCountriesInfoPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.Idm/ListCountriesInfo',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List Offices Info
 */
export const listOfficesInfoPassportIdmIdmListOfficesInfoPost = <ThrowOnError extends boolean = false>(
  options: Options<ListOfficesInfoPassportIdmIdmListOfficesInfoPostData, ThrowOnError>,
): RequestResult<
  ListOfficesInfoPassportIdmIdmListOfficesInfoPostResponses,
  ListOfficesInfoPassportIdmIdmListOfficesInfoPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ListOfficesInfoPassportIdmIdmListOfficesInfoPostResponses,
    ListOfficesInfoPassportIdmIdmListOfficesInfoPostErrors,
    ThrowOnError
  >({
    url: '/passport.idm.Idm/ListOfficesInfo',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get Allocated Active Coins Per Month
 *
 * Name: Added active coins per month
 * Shows the active coins added to the system by month. Depends on the number of users and on how actively users
 * transferred coins in the previous month. The more coins added, the larger should be the budget for the store
 *
 * Имя: Добавленные активные монеты по месяцам
 * Показывает добавленные в систему монеты для передачи в разрезе по месяцам. Зависит от количества пользователей и от
 * того, насколько активно пользователи переводили монеты в предыдущем месяце. Чем больше монет добавлено, тем больше
 * должен быть бюджет на магазин
 */
export const getAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetData, ThrowOnError>,
): RequestResult<
  GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetResponses,
  GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetResponses,
    GetAllocatedActiveCoinsPerMonthStatisticsCoinsActiveAllocatedPerMonthGetErrors,
    ThrowOnError
  >({ url: '/statistics/coins/active/allocated/per-month', ...options })

/**
 * Get Current Sum Of Usable Coins
 *
 * Name: Current usable coins count
 * Shows the current number of coins that users can spend in the store. This number displays the current theoretically
 * in the store. This number displays the current theoretically possible maximum budget for the store. Does count coins
 * of blocked users.
 *
 * Имя: Текущее количество монет для покупок
 * Показывает текущее количество монет, которые пользователи могут потратить в магазине. Это число отображает текущий
 * теоретически возможный максимальный бюджет на магазин. Не учитывает монеты заблокированных пользователей.
 */
export const getCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetData, ThrowOnError>,
): RequestResult<
  GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetResponses,
  GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetResponses,
    GetCurrentSumOfUsableCoinsStatisticsCoinsUsableCurrentSumGetErrors,
    ThrowOnError
  >({ url: '/statistics/coins/usable/current-sum', ...options })

/**
 * Get Usable Coins Per User
 *
 * Name: Usable coins per user
 * Shows the number of coins users can spend in the store per user. Does count coins of blocked users.
 *
 * Имя: Монеты для покупок по пользователям
 * Показывает количество монет, которые пользователи могут потратить в магазине, в разрезе по пользователям. Не
 * включает заблокированных пользователей.
 */
export const getUsableCoinsPerUserStatisticsCoinsUsablePerUserGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetData, ThrowOnError>,
): RequestResult<
  GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetResponses,
  GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetResponses,
    GetUsableCoinsPerUserStatisticsCoinsUsablePerUserGetErrors,
    ThrowOnError
  >({ url: '/statistics/coins/usable/per-user', ...options })

/**
 * Get Spent Coins Per Month
 *
 * Name: Spent coins per month
 * Shows the number of coins that users have spent in the store broken down by month. Allows you to forecast the real
 * budget for the store for a month
 *
 * Имя: Потрачено монет по месяцам
 * Показывает количество монет, которые пользователи потратили в магазине
 * в разрезе по месяцам. Позволяет прогнозировать реальный бюджет на магазин на месяц
 */
export const getSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetData, ThrowOnError>,
): RequestResult<
  GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetResponses,
  GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetResponses,
    GetSpentCoinsPerMonthStatisticsCoinsSpentPerMonthGetErrors,
    ThrowOnError
  >({ url: '/statistics/coins/spent/per-month', ...options })

/**
 * Get Usable Avarage Per Month
 *
 * Name: Usable avarage coins count per month
 * Shows the average number of coins users have in their usable account by month. Helps to understand whether coins are
 * accumulated (risk of future spending spikes) or constantly spent (stabilization of spending). Indirectly shows
 * whether interesting or not products are presented in the store. Does not count coins of blocked users.
 *
 * Имя: Среднее количество монет на счету по месяцам
 * Показывает среднее количество монет, которые пользователи имеют на счету кошелька в разрезе по месяцам. Помогает
 * понять, накапливаются ли монеты (риск скачков расходов в будущем) или постоянно расходуются (cтабилизации расходов).
 * Косвенно показывает, интересные ли товары представлены в магазине. Не учитывает монеты заблокированных
 * пользователей.
 */
export const getUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetData, ThrowOnError>,
): RequestResult<
  GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetResponses,
  GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetResponses,
    GetUsableAvaragePerMonthStatisticsCoinsUsableAvaragePerMonthGetErrors,
    ThrowOnError
  >({ url: '/statistics/coins/usable-avarage/per-month', ...options })

/**
 * Get User Engagement Per Month
 *
 * Name: User engagement per month
 * Shows the number of users who have made a purchase or transfer by month. Allows you to understand the activity of
 * using the rewards system and the dynamics of this activity.
 *
 * Имя: Активность пользователей по месяцам
 * Показывает количество пользователей, которые совершили покупку или перевод в разрезе по месяцам.
 * Позволяет понять активность использования системы поощрений и динамику этой активности.
 */
export const getUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetData, ThrowOnError>,
): RequestResult<
  GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetResponses,
  GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetResponses,
    GetUserEngagementPerMonthStatisticsCoinsUserEngagementPerMonthGetErrors,
    ThrowOnError
  >({ url: '/statistics/coins/user-engagement/per-month', ...options })

/**
 * Get Transfer Stats Per Month
 *
 * Name: Transfer stats per month
 * Shows the number of transfers and the average amount of transfers by month.
 * Allows you to understand how actively users thank each other and in what amount.
 *
 * Имя: Статистика переводов по месяцам
 * Показывает количество переводов и среднюю сумму переводов в разрезе по месяцам.
 * Позволяет понять, насколько активно пользователи благодарят друг друга, и в каком количестве.
 */
export const getTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetData, ThrowOnError>,
): RequestResult<
  GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetResponses,
  GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetResponses,
    GetTransferStatsPerMonthStatisticsCoinsTransferStatsPerMonthGetErrors,
    ThrowOnError
  >({ url: '/statistics/coins/transfer-stats/per-month', ...options })

/**
 * Upload Image
 */
export const uploadImageMediaUploadPost = <ThrowOnError extends boolean = false>(
  options: Options<UploadImageMediaUploadPostData, ThrowOnError>,
): RequestResult<UploadImageMediaUploadPostResponses, UploadImageMediaUploadPostErrors, ThrowOnError> =>
  (options.client ?? client).post<UploadImageMediaUploadPostResponses, UploadImageMediaUploadPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/media/upload',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  })

/**
 * Get Image
 */
export const getImageProxyMediaIdImgproxyProcessingOptionsGet = <ThrowOnError extends boolean = false>(
  options: Options<GetImageProxyMediaIdImgproxyProcessingOptionsGetData, ThrowOnError>,
): RequestResult<
  GetImageProxyMediaIdImgproxyProcessingOptionsGetResponses,
  GetImageProxyMediaIdImgproxyProcessingOptionsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetImageProxyMediaIdImgproxyProcessingOptionsGetResponses,
    GetImageProxyMediaIdImgproxyProcessingOptionsGetErrors,
    ThrowOnError
  >({ url: '/proxy/{media_id}{imgproxy_processing_options}', ...options })
